// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

// Bridge mutations
export const ERR_CRE_BRIDGE = 'Failed to create bridge request';
export const ERR_REJ_BRIDGE = 'Failed to reject bridge request';
export const SUC_CRE_BRIDGE = 'Successfully created bridge request';
export const SUC_REJ_BRIDGE = 'Successfully rejected bridge request';
export const ERR_REQ_BUA_SVC = 'Failed to request user agreement';
export const SUC_REQ_BUA_SVC = 'Successfully requested user agreement';
export const SUC_TER_BRIDGE_USER_AGREEMENT = 'Successfully terminated user agreement';
export const ERR_TER_BRIDGE_USER_AGREEMENT = 'Failed to terminate user agreement';
export const SUC_REJ_BRIDGE_USER_AGREEMENT = 'Successfully rejected user agreement';
export const ERR_REJ_BRIDGE_USER_AGREEMENT = 'Failed to reject user agreement';
export const ERR_ACC_BRIDGE_USER_AGREEMENT = 'Failed to accept user agreement';
export const SUC_ACC_BRIDGE_USER_AGREEMENT = 'Successfully accepted user agreement';
export const SUC_REQ_BRIDGE = 'Successfully burnt holding';
export const ERR_REQ_BRIDGE = 'Failed to burn holding';
export const SUC_MINT_HOLDING = 'Successfully minted holding';
export const ERR_MINT_HOLDING = 'Failed to mint holding';
export const ERR_ACC_BRIDGE_AGREEMENT = 'Failed to accept bridge agreement offer';
export const SUC_ACC_BRIDGE_AGREEMENT = 'Successfully accepted bridge agreement offer';
export const ERR_ACC_BRIDGE_SERVICE = 'Failed to accept bridge agreement request';
export const SUC_ACC_BRIDGE_SERVICE = 'Successfully accepted bridge agreement request';
export const ERR_CRE_DEPOSIT_ATTESTATION = 'Failed to create deposit attestation';
export const SUC_CRE_DEPOSIT_ATTESTATION = 'Successfully created deposit attestation';
